
export const getProjectType = (context, createdBy, parameters) => {
  const { type } = parameters.mutation
  return type.toLowerCase()
}
